<template>
    <div class="flex flex-col items-center">
        {{ $t('A Generic True-False Question') }}

        <div class="flex my-4">
            <button class="mx-2" @click="answer(true)">
                {{ $t('Answer True') }}
            </button>

            <button class="mx-2" @click="answer(false)">
                {{ $t('Answer False') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {},
    },

    methods: {
        answer(value) {
            this.$emit('answered', value);
        }
    },
}
</script>
